import {combineReducers} from "@ngrx/store";

import * as fromPublications from '../../modules/landing-publication/store/currentPublication.reducers';


export interface UserContext {
    currentPublication: fromPublications.State;
}

export const userContextInitialState = {
    currentPublication: fromPublications.initialState,
}

export const reducer = combineReducers(
    {
        currentPublication: fromPublications.reducer,
    },
    userContextInitialState,
);
